import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../../../components/buttons';
import { renderTextField } from '../../../../../../components/reduxFields';
import SignaturePad from 'react-signature-pad';


const requireGuardian = (value) => !value ? 'Please enter guardian name' : null;

class SignatureModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      clear: false,
      isLoading: false,      
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.resetClear = this.resetClear.bind(this);    
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  handleClear = () => {
    var signature = this.refs.mySignature;

    signature.clear();
  }

  // componentDidMount() {
  //   this.resizeCanvas();
  // }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  // resizeCanvas() {
  //   var canvas = this.refs.mySignature;
  //   var ratio = Math.max(window.devicePixelRatio || 1, 1);
  //   canvas.width = canvas.offsetWidth * ratio;
  //   canvas.height = canvas.offsetHeight * ratio;
  //   // canvas.getContext('2d').scale(ratio, ratio);
  //   // signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  // }


  resetClear(evt) {
    this.setState({ clear: false });
  }

  onSubmitHandler = (formProps) => {
    var signature = this.refs.mySignature;
    if (signature.isEmpty()) {
      return false;
    }

    this.setState({ isLoading: true });
    let self = this;
    var imageBytes = signature.toDataURL(); // toDataURL generates base64 bytes as png image.
    formProps.signBytes = imageBytes;
    self.setState({ isLoading: false });
    self.props.handleAddSign(formProps);
    self.handleClose();
  }


  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={this.handleClose}/>,
      <CommonButton label= "Clear" primary={true} className="mr-15" onTouchTap={this.handleClear}/>,
      <CommonButton type="submit" primary={true} label= "Done" onTouchTap={handleSubmit(this.onSubmitHandler)}/>,
    ];
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={'Add Guardian Signature'}
            modal={false}
            open={this.state.open}
            actions={actions}
            repositionOnUpdate={false}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-12 require">
                    <Field
                      name="Guardian"
                      type="text"
                      label="Guardian Name"
                      maxLength={20}
                      validate={[requireGuardian]}
                      component={renderTextField}
                    />
                  </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div id="signCanvas">
                        <SignaturePad ref="mySignature"/>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.patient.loading
  };
};

SignatureModal = reduxForm({
  form: 'SignatureModal',  
})(SignatureModal);

export default connect(mapStateToProps, null)(SignatureModal);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/ManageAppointments/components/appointments/signature_modal.js